module.exports = __webpack_public_path__ + "static/media/alert-red-icon.934f4ba4.svg";